/** The platform server's OP-warehouse routes (MPN-2229). Read at call time so tests can stub the env. */
export function legacyDashboardUrl(path: string): URL {
    return new URL(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/legacy_dashboard/${path}`);
}
